import {
  FETCH_CENTRE_MANAGEMENT_CONFIG,
  CREATE_OR_UPDATE_CENTRE,
} from './actionTypes';
import {
  GET_CENTRE_MANAGEMENT_CONFIG,
  CREATE_OR_UPDATE_SCHOOL_CENTRE,
  GET_MARKETING_CONSENT_UPLOAD_URL,
  UPDATE_MARKETING_CONSENT,
} from '../models/centreManagementModel';
import { SkApolloRequest } from '../../utils/apolloUtils';

const dispatchFetchCentreManagementConfig = (
  dispatch,
  inProgress = true,
  data = [],
  error = null
) => {
  dispatch({
    type: FETCH_CENTRE_MANAGEMENT_CONFIG,
    key: 'centreManagementConfig',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchCreateOrUpdateCentre = (
  dispatch,
  inProgress = true,
  data = [],
  error = null
) => {
  dispatch({
    type: CREATE_OR_UPDATE_CENTRE,
    key: 'createOrUpdateCentre',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

export const fetchCentreManagementConfig = schoolID => async dispatch => {
  dispatchFetchCentreManagementConfig(dispatch);
  try {
    const result = await SkApolloRequest({
      params: {
        query: GET_CENTRE_MANAGEMENT_CONFIG,
        variables: {
          fkSchool: schoolID,
        },
      },
      type: 'query',
    });

    if (result.success) {
      dispatchFetchCentreManagementConfig(dispatch, false, result.data);
    } else {
      dispatchFetchCentreManagementConfig(dispatch, false, null, result.error);
    }
  } catch (err) {
    dispatchFetchCentreManagementConfig(dispatch, false, null, {
      error: err.message,
    });
  }
};

export const createOrUpdateSchoolCentre = reqData => async dispatch => {
  dispatchCreateOrUpdateCentre(dispatch);
  try {
    const {
      fkSchool,
      fkCentre,
      centreData,
      postcodes,
      levels,
      addressData,
      workplaces,
      centreAutoPromotionConfigs,
    } = reqData;

    const result = await SkApolloRequest({
      params: {
        query: CREATE_OR_UPDATE_SCHOOL_CENTRE,
        variables: {
          schoolID: fkSchool,
          centreID: fkCentre,
          centreData,
          postcodes,
          levels,
          addressData,
          workplaces,
          centreAutoPromotionConfigs,
        },
        type: 'mutation',
      },
    });

    if (result.success) {
      dispatchCreateOrUpdateCentre(dispatch, false, result.data);
    } else {
      dispatchCreateOrUpdateCentre(dispatch, false, null, result.error);
    }
    return result;
  } catch (err) {
    dispatchCreateOrUpdateCentre(dispatch, false, null, {
      error: err.message,
    });
  }
};

export const getMarketingConsentDocumentUploadURL = reqData => async () => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: GET_MARKETING_CONSENT_UPLOAD_URL,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    return ex;
  }
};

export const updateMarketingConsentDashboard = reqData => async () => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: UPDATE_MARKETING_CONSENT,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    return ex;
  }
};

export default fetchCentreManagementConfig;
